import type { ReactNode } from "react";

/** Zahlenfeld mit Einheit – Eingaben wirken sofort, ohne Bestätigen. */
export function ZahlFeld({
  label, wert, onChange, einheit, min, max, schritt = 1, breit,
}: {
  label: ReactNode; wert: number; onChange: (n: number) => void; einheit?: string; min?: number; max?: number; schritt?: number; breit?: boolean;
}) {
  return (
    <label className={`kalk-feld${breit ? " kalk-feld--breit" : ""}`}>
      <span className="kalk-feld__label">{label}</span>
      <span className="kalk-feld__eingabe">
        <input
          type="number"
          inputMode="decimal"
          value={Number.isFinite(wert) ? wert : ""}
          min={min}
          max={max}
          step={schritt}
          onChange={(e) => onChange(e.target.value === "" ? NaN : Number(e.target.value))}
        />
        {einheit && <span className="kalk-feld__einheit">{einheit}</span>}
      </span>
    </label>
  );
}

export function AuswahlFeld<T extends string>({
  label, wert, onChange, optionen,
}: { label: ReactNode; wert: T; onChange: (v: T) => void; optionen: { wert: T; label: string }[] }) {
  return (
    <label className="kalk-feld">
      <span className="kalk-feld__label">{label}</span>
      <select value={wert} onChange={(e) => onChange(e.target.value as T)}>
        {optionen.map((o) => (
          <option key={o.wert} value={o.wert}>{o.label}</option>
        ))}
      </select>
    </label>
  );
}

export function TextFeld({ label, wert, onChange, platzhalter }: { label: ReactNode; wert: string; onChange: (v: string) => void; platzhalter?: string }) {
  return (
    <label className="kalk-feld">
      <span className="kalk-feld__label">{label}</span>
      <input type="text" value={wert} placeholder={platzhalter} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}

/** Schalter: reagiert beim Drücken, nicht erst beim Loslassen. */
export function Schalter({ label, an, onChange }: { label: ReactNode; an: boolean; onChange: (an: boolean) => void }) {
  return (
    <button type="button" role="switch" aria-checked={an} className={`kalk-schalter${an ? " kalk-schalter--an" : ""}`} onPointerDown={(e) => { e.preventDefault(); onChange(!an); }} onKeyDown={(e) => { if (e.key === " " || e.key === "Enter") { e.preventDefault(); onChange(!an); } }}>
      <span className="kalk-schalter__knopf" aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
